
// common config for the vega vizs
export const VEGA_CONFIG = {
    title: {
        fontFamily: 'Zilla Slab'
    }
};

export const DEPLOY_URL = '';
export const DEPLOY_FOLDER = '';